/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.printHalls = function( arr) {
    var obj = {};
    var len = arr.length;
    obj.content = document.createElement( "div");
    var i = 0;
    var par = null;
        //  move to header, put list specific stuff here
    obj.style = "div{padding-left:20px;}";
    
    for( i = 0; i < len; i++) {
        par = document.createElement( "p");
        par.textContent = arr[i].label;
        obj.content.appendChild( par);
    }
    return obj;
};